import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CustomCssTransition from './CustomCssTransition';

//////////////////////////

const useStyles = makeStyles({

  default: {
    opacity: 0,
  },
  transitions: props => ({
    '&.entering': {
      transition: `opacity ${props.entryDuration}ms linear`,
      opacity: 1,
    },
    '&.entered': {
      opacity: 1
    },
    '&.exiting': {
      transition: `opacity ${props.exitDuration}ms linear`,
      opacity: 0,
    },
    '&.exited': {
      opacity: 0
    },
  }),

})

//////////////////////////

const defaultProps = {
  duration: 250,
  id: "fade",
};

export const TransitionFade = props => {
  
  const {id} = props;

  //////
  
  return (
    <CustomCssTransition
      {...props}
      id = {id}
      useStyles = {useStyles}
      >
      {props.children}
    </CustomCssTransition>
  );

};

TransitionFade.defaultProps = defaultProps;
export default TransitionFade;
